module.exports = __webpack_public_path__ + "static/img/ent-detail-71.8da7714.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-71.jpg
// module id = pS8j
// module chunks = 52